import axios from 'axios';

// Teams axios instance (similar to axiosInstance5 for Slack)
const axiosInstanceEvents = process.env.NODE_ENV === 'production' ? axios.create({
  baseURL: 'https://ricotta-events-lgdoz.ondigitalocean.app/'
}) : 
axios.create({
  baseURL: 'http://localhost:5001/'
});

export default axiosInstanceEvents;